import React from 'react';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { setShowBugReportForm } from 'store/actions/general';
import './bug-report-button.css';

export default function BugReportButton() {
  const dispatch = useDispatch();
  const onShowBugReportForm = () => dispatch(setShowBugReportForm(true));

  return (
    <Button
      className="bug-report-button"
      type="primary"
      shape="circle"
      icon="bug"
      size="large"
      onClick={onShowBugReportForm}
    />
  );
}
